import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { Bell, Images, Users, UserCog, ArrowRight } from "lucide-react";

export default function AdminDashboard() {
  const [counts, setCounts] = useState({});
  useEffect(() => {
    Promise.all([
      api.get("/notices"), api.get("/events"), api.get("/executives"), api.get("/members"),
    ]).then(([n, e, x, m]) => setCounts({ notices: n.data.length, events: e.data.length, executives: x.data.length, members: m.data.length }));
  }, []);

  const cards = [
    { to: "/admin/notices", label: "Notices", icon: Bell, count: counts.notices },
    { to: "/admin/gallery", label: "Gallery Events", icon: Images, count: counts.events },
    { to: "/admin/executives", label: "Executive Body", icon: UserCog, count: counts.executives },
    { to: "/admin/members", label: "Bar Members", icon: Users, count: counts.members },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h2 className="font-display text-2xl text-[#0B2E63] font-bold mb-1">Welcome back</h2>
      <p className="text-[#5A6270] mb-8">Manage all website content from here. Changes appear live on the public site.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {cards.map((c) => (
          <Link key={c.to} to={c.to} className="card-elite rounded-xl p-6" data-testid={`dash-${c.label.toLowerCase().replace(/\s+/g, "-")}`}>
            <c.icon className="text-[#8A6320] mb-3" size={26} />
            <div className="font-display text-3xl font-bold text-[#0B2E63]">{c.count ?? "—"}</div>
            <div className="text-sm text-[#5A6270] flex items-center gap-1 mt-1">{c.label} <ArrowRight size={13} /></div>
          </Link>
        ))}
      </div>
    </div>
  );
}
